import { render, staticRenderFns } from "./nav-ai-helper.vue?vue&type=template&id=149054a8&scoped=true"
import script from "./nav-ai-helper.vue?vue&type=script&lang=js"
export * from "./nav-ai-helper.vue?vue&type=script&lang=js"
import style0 from "./nav-ai-helper.vue?vue&type=style&index=0&id=149054a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149054a8",
  null
  
)

export default component.exports